var map = {
	"./certificate-en-short.png": "df5c",
	"./certificate-en.png": "25ef",
	"./certificate-es.png": "92a7",
	"./certificate-ja.png": "1923",
	"./collection-en-short.png": "51a3",
	"./collection-en.png": "248e",
	"./collection-es.png": "8445c",
	"./collection-ja.png": "7f26",
	"./frames.png": "6fb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1b9";